/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./required-field.component";
var styles_RequiredFieldComponent = [];
var RenderType_RequiredFieldComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_RequiredFieldComponent, data: {} });
export { RenderType_RequiredFieldComponent as RenderType_RequiredFieldComponent };
export function View_RequiredFieldComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "span", [["class", "text-danger"]], null, null, null, null, null)), (_l()(), i0.ɵted(-1, null, ["(*)"]))], null, null); }
export function View_RequiredFieldComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-required-field", [], null, null, null, View_RequiredFieldComponent_0, RenderType_RequiredFieldComponent)), i0.ɵdid(1, 114688, null, 0, i1.RequiredFieldComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var RequiredFieldComponentNgFactory = i0.ɵccf("app-required-field", i1.RequiredFieldComponent, View_RequiredFieldComponent_Host_0, {}, {}, []);
export { RequiredFieldComponentNgFactory as RequiredFieldComponentNgFactory };
